import axios from "axios";
import {
  FETCH_ANIMALS,
  CREATE_ANIMAL,
  UPDATE_ANIMAL,
  DELETE_ANIMAL,
  UPDATE_DEFAULT_ANIMAL,
  interceptor,
  CLEAR_ANIMAL_TYPE
} from ".";
import store from "../store";
// import { BASE_URL } from "../utils/helper";

interceptor(axios, store);
export function createAnimalType(pet) {
  return {
    type: CREATE_ANIMAL,
    payload: axios.post(`${process.env.REACT_APP_API_ENDPOINT}/core/pet/`, pet, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function fetchAnimalTypes() {
  return {
    type: FETCH_ANIMALS,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/pet/`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function updateDefault(pet) {
  return {
    type: UPDATE_DEFAULT_ANIMAL,
    payload: axios.put(`${process.env.REACT_APP_API_ENDPOINT}/core/pet/default/${pet.id}`, pet, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function clear() {
  return {
    type: CLEAR_ANIMAL_TYPE,
    payload: null
  };
}

export function getEditable(edited) {
  return {
    type: UPDATE_ANIMAL,
    payload: axios.put(`${process.env.REACT_APP_API_ENDPOINT}/core/pet/${edited.id}`, edited, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function getDeletable(selected) {
  const ids = { ids: selected };
  return {
    type: DELETE_ANIMAL,
    payload: axios.post(`${process.env.REACT_APP_API_ENDPOINT}/core/pet/delete/`, ids, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}
